import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '../Buttons/Button';

import './Dialog.scss';

const AlertDialog = props => {
  const { open, onClose, title, message, onNo, onYes } = props;

  return (
    <Dialog className="rsa-dialog" open={open} onClose={onClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
      {title && <DialogTitle id="alert-dialog-title">{title}</DialogTitle>}

      {message && (
        <DialogContent>
          <DialogContentText id="alert-dialog-description">{message}</DialogContentText>
        </DialogContent>
      )}

      <DialogActions>
        <Button onClick={onNo} buttonStyle="destructive" className="btn-no">
          No
        </Button>
        <Button onClick={onYes} buttonStyle="primary" className="btn-yes">
          Yes
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AlertDialog;
